import React from 'react';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { Loader } from './styled';

export const Spinner = ({ active, size, inline }) => {
  const classes = serializeClasses([
    active && 'active',
    inline && 'inline',
    size,
  ]);

  return <Loader className={classes} />;
};

Spinner.propTypes = {
  active: PropTypes.bool,
  inline: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

Spinner.defaultProps = {
  active: true,
  inline: false,
  size: 'small',
};
